import { auth, firestore, User } from 'firebase/app';
import DocumentSnapshot = firestore.DocumentSnapshot;

import { UserWebMapper } from '@/web/dao/user/UserWebMapper';
import { UserDAO } from 'sparkello-core';
import { UserVuexStore } from '@/web/dao/user/UserVuexStore';


export class UserWebDAO extends UserDAO<DocumentSnapshot, User, typeof auth, typeof firestore>{

  private static singleton: UserWebDAO;

  public static get instance(): UserWebDAO {
    if (!UserWebDAO.singleton) {
      UserWebDAO.singleton = new UserWebDAO();
    }
    return this.singleton;
  }

  public constructor() {
    super(new UserWebMapper(), new UserVuexStore(), auth, firestore);
    return this;
  }
}
